export default {
  setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setRecommendations(state, recommendations) {
    state.recommendations = recommendations;
  },
  setRecommendationProfile(state, recommendationProfile) {
    state.recommendationProfile = recommendationProfile;
  },
  setRecommendationTotal(state, recommendationTotal) {
    state.recommendationTotal = recommendationTotal;
  },
  setComissions(state, comissions) {
    state.comissions = comissions;
  }
};
